import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import Logo from '../assets/img/logo.png';

const Footer: React.FC = () => {
  return (
    <footer className="bg-neutral-900 text-white py-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4 mt-12">
        {/* Company Name */}
        <div className="text-xl font-bold mb-0 flex lg:justify-center flex-col justify-center items-center lg:flex-row lg:items-center">
          <img src={Logo} alt="logo" className="w-20 h-22  " />
         <span className='lg:mt-1 mt-1 text-xl lg:text-2xl  '>Adins International Pvt. Ltd.</span> 
        </div>

        {/* Links Section */}
        <div className="flex lg:flex-col lg:space-y-2 lg:text-center text-center space-y-0 flex-row space-x-8 mt-6 lg:mt-0 lg:space-x-0">
          <a href="/aboutus" className="hover:text-gray-300 transition-colors hover:underline">
            About Us
          </a>
          <a href="/products" className="hover:text-gray-300 transition-colors hover:underline">
            Products
          </a>
          <a href="/services" className="hover:text-gray-300 transition-colors hover:underline">
            Services
          </a>
        </div>

        {/* Contact Info Section */}
        <div className="mt-4 md:mt-0 text-center md:text-right">
          <h4 className="font-semibold text-center">Contact Us</h4>
          <p>Email: <a href="mailto:info@adins.com" className="hover:text-gray-300 transition-colors">info@adinsinternational.com</a></p>
          <p>Address: Plot No. 1, Jagat Khera Rd,</p>
            <p>near to Saint Martin Academy, Jagat</p>   
             <p>khera, Kalli Pashchim, Lucknow,</p>
              <p>Uttar Pradesh 226014, India</p>
          <p>Mobile: +919151816021</p>
        </div>

        {/* Social Media Icons */}
        <div className="mt-4 md:mt-0 flex space-x-4 justify-center md:justify-end mb-4 md:mb-0">
          <a href="https://www.facebook.com/adinsinternational" target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="h-6 w-6 hover:text-blue-600 transition-colors" />
          </a>
          <a href="https://x.com/adinsinternati8" target="_blank" rel="noopener noreferrer">
            <FaTwitter className="h-6 w-6 hover:text-blue-400 transition-colors" />
          </a>
          <a href="https://www.linkedin.com/company/adins-international/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn className="h-6 w-6 hover:text-blue-700 transition-colors" />
          </a>
          <a href="https://www.instagram.com/adins.international/?igsh=MTE4OHVvd2JienBpdA%3D%3D#" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="h-6 w-6 hover:text-pink-500 transition-colors" />
          </a>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="border-t border-gray-700 pt-4 text-center text-sm mt-16">
        &copy; {new Date().getFullYear()} Adins International Pvt. Ltd. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
